import { BackofficeContactsSetupInterface } from '../../../../../interfaces/dto/backoffice-contacts-setup/backoffice-contacts-setup/backoffice-contacts-setup-interface';

export class BackofficeContactsSetupModel implements BackofficeContactsSetupInterface {
  contactBuildingList: Array<object> = new Array<object>();
  contactTypeList: Array<object> = new Array<object>();
  partnership: object = {};
}
